import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18n } from "@/shared/hooks";
import { useTestId } from "@/hooks";
import { useRefsContext } from "@/contexts/ref";
import { Title, Section } from "@/components/UI";
import { EnergyModal, EnergyFeatures, Certificate, } from "@/components/Sections/Energy";
import { useEnergy } from ".";
export const Energy = () => {
    const { t } = useI18n();
    const testId = useTestId("Sections.Energy");
    const { energyRef } = useRefsContext();
    const { hasData, hasScales, maximumDisplayedCertificates, features } = useEnergy();
    if (!hasData)
        return null;
    return (_jsxs(Section, { ref: energyRef, testId: testId, children: [_jsx(Title, { title: t("energy.headline"), variant: "section", testId: `${testId}.Title`, id: "energy" }), hasScales && (
            // "hasScales" is false only for IMN/IWT "international" classifieds
            // in this case we do not display certificates at all otherwise we display alternateText
            _jsx(_Fragment, { children: maximumDisplayedCertificates === null || maximumDisplayedCertificates === void 0 ? void 0 : maximumDisplayedCertificates.map((certificate) => (_jsx(Certificate, { certificate: certificate, variant: "preview" }, certificate.key))) })), _jsx(EnergyFeatures, { features: features, rootTestId: `${testId}.Features`, variant: "preview" }), _jsx(EnergyModal, {})] }));
};
